<template>
  <ChecklistModal
    :title="options.label"
    v-model="valueComp"
    :items="options.items"
    :transform="transform"
    :group-by="options.groupBy"
  >
    <template #input="{ items }">
      <div class="elder-input">
        <label class="elder-input__label">{{ options.label }}</label>
        <ButtonComponent class="elder-input__wrapper" :icon="iconComp" icon-placement="left">
          <template #label>
            <span v-html="getLabel(items)"></span>
            <Badge class="ml-1" v-if="items.length > limit" :value="`+ ${items.length - limit}`" />
            <FontAwesomeIcon class="ml-1" :icon="['fal', 'angle-down']" size="lg" />
          </template>
        </ButtonComponent>
      </div>
    </template>
  </ChecklistModal>
</template>

<script>
import { ToArray } from '@/utils'
import { ButtonComponent } from 'vue-elder-button'
import ChecklistModal from '@/components/Select/ChecklistModal'
import Badge from '@/components/Badge'

export default {
  props: ['value', 'options'],
  data() {
    return {
      limit: 1,
    }
  },
  computed: {
    valueComp: {
      get() {
        return (this.$path('options.items') || []).filter(({ id }) => ToArray(this.value).filter(Boolean).includes(id))
      },
      set(val) {
        this.$emit(
          'input',
          val.map(({ id }) => id),
        )
      },
    },
    iconComp() {
      return this.options.icon ? this.options.icon : null
    },
  },
  methods: {
    transform(item) {
      if (!this.options.transform) return item
      return typeof this.options.transform === 'function'
        ? this.options.transform({ value: this.value, options: this.options, item })
        : this.options.transform
    },
    getLabel(items) {
      return items.length
        ? `${items
            .slice(0, this.limit)
            .map(({ name }) => name)
            .join(', ')}`
        : this.options.label
    },
  },
  components: {
    ChecklistModal,
    ButtonComponent,
    Badge,
  },
}
</script>
